var writtenNumber = require('written-number');

writtenNumber.defaults.lang = 'fr';

export default writtenNumber;